import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import useStyles from './styles/RatePlansPoliciesListTableHead.styles'

interface RatePlansPoliciesListTableHeadProps {
  reloadData: () => void
}
const RatePlansPoliciesListTableHead: React.FC<
  RatePlansPoliciesListTableHeadProps
> = ({ reloadData }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body1">{getTranslate('Name')}</Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('From')}</Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('To')}</Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('Action')}</Typography>
      </div>
      <div>
        <IconButton
          onClick={() => {
            reloadData()
          }}>
          <RefreshIcon />
        </IconButton>
      </div>
    </div>
  )
}
export default RatePlansPoliciesListTableHead
